import { hasLoggedInCookie, mockApi } from "../api.js";
const A = "#C8A050";
const TD = "#7a7468";
const PRE_HUB_COMMANDS = [
    { id: "create-hub", label: ":create-hub", description: "создать новый хаб" },
    { id: "price", label: ":price", description: "тарифы" },
    { id: "offer", label: ":offer", description: "оферта" },
];
const POST_HUB_COMMANDS = [
    { id: "status", label: ":status", description: "статус хаба" },
    { id: "claude", label: ":claude", description: "конфиг Claude Code" },
    { id: "codex", label: ":codex", description: "конфиг Codex" },
    { id: "opencode", label: ":opencode", description: "конфиг OpenCode" },
    { id: "open-pay", label: ":open-pay", description: "пополнить счет" },
    { id: "open-account", label: ":open-account", description: "личный кабинет" },
    { id: "price", label: ":price", description: "тарифы" },
    { id: "offer", label: ":offer", description: "оферта" },
];
const hasCreatedHub = () => {
    if (mockApi || hasLoggedInCookie())
        return true;
    const hubName = document.getElementById("hub-name-link")?.textContent?.trim();
    return Boolean(hubName);
};
const runCommand = (commandId) => {
    document.dispatchEvent(new CustomEvent("hub-for-programmers:run-command", { detail: commandId }));
};
export function addMobileCommandPalette() {
    const palette = document.getElementById("mobile-palette");
    const backdrop = document.getElementById("mobile-palette-bd");
    const cmdsContainer = document.getElementById("mobile-palette-cmds");
    const helpLink = document.getElementById("less-help-link");
    if (!palette || !backdrop || !cmdsContainer)
        return;
    const isTouchDevice = () => navigator.maxTouchPoints > 0 || "ontouchstart" in window;
    const populateCommands = () => {
        const commands = hasCreatedHub() ? POST_HUB_COMMANDS : PRE_HUB_COMMANDS;
        cmdsContainer.replaceChildren();
        for (const cmd of commands) {
            const btn = document.createElement("button");
            btn.type = "button";
            const labelSpan = document.createElement("span");
            labelSpan.textContent = cmd.label;
            labelSpan.style.cssText = `color:${A};font-size:13px;font-family:inherit;letter-spacing:0.04em;`;
            const descSpan = document.createElement("span");
            descSpan.textContent = cmd.description;
            descSpan.style.cssText = `color:${TD};font-size:12px;font-family:inherit;`;
            btn.appendChild(labelSpan);
            btn.appendChild(descSpan);
            btn.addEventListener("click", () => {
                close();
                runCommand(cmd.id);
            });
            cmdsContainer.appendChild(btn);
        }
    };
    let closeTimeout = null;
    const close = () => {
        if (closeTimeout !== null)
            return;
        palette.classList.add("is-closing");
        palette.classList.remove("is-entering");
        closeTimeout = window.setTimeout(() => {
            palette.classList.remove("is-open", "is-closing");
            closeTimeout = null;
        }, 240);
    };
    const open = () => {
        if (closeTimeout !== null) {
            window.clearTimeout(closeTimeout);
            closeTimeout = null;
        }
        populateCommands();
        palette.classList.add("is-open", "is-entering");
        palette.classList.remove("is-closing");
    };
    backdrop.addEventListener("click", close);
    // Swipe-down to close: track touch start and end on the sheet
    const sheet = document.getElementById("mobile-palette-sheet");
    if (sheet) {
        let touchStartY = 0;
        sheet.addEventListener("touchstart", (e) => {
            touchStartY = e.touches[0]?.clientY ?? 0;
        }, { passive: true });
        sheet.addEventListener("touchend", (e) => {
            const dy = (e.changedTouches[0]?.clientY ?? 0) - touchStartY;
            if (dy > 60)
                close();
        }, { passive: true });
    }
    // Intercept :help link click on touch devices — open palette instead
    if (helpLink) {
        helpLink.addEventListener("click", (event) => {
            if (!isTouchDevice())
                return;
            event.preventDefault();
            event.stopImmediatePropagation();
            open();
        }, { capture: true });
    }
    // Re-populate when hub is created so commands update without page reload
    document.addEventListener("hub-for-programmers:hub-created", () => {
        if (palette.classList.contains("is-open")) {
            populateCommands();
        }
    });
}
